import { Injectable } from "@angular/core";
import { AConfigurationsFacade, ConfigurationService, handleError } from "@coso-replicator/core";
import { ALoggerService } from "@coso/logger";
import { Subscription, timer } from "rxjs";
import { filter, mergeMap, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class ConfigurationsFacade extends AConfigurationsFacade {
  private _subscription: Subscription;
  private _page: number;
  private _pageSize: number;
  private _filterText: string;
  private _isLoading: boolean;

  constructor(private configService: ConfigurationService, private logger: ALoggerService) {
    super();
  }

  load(page: number, pageSize: number, filterText?: string): void {
    /** Initialize local variables to be reused between calls */
    this._page = page - 1;
    this._pageSize = pageSize;
    this._filterText = filterText;
    this._isLoading = false;

    if (this._subscription) {
      this.logger.log("call unsubscribe");
      this._subscription.unsubscribe();
    }

    this.logger.log("reload", this._page, this._pageSize, this._filterText);
    /** Setup timer */
    this._subscription = timer(0, 10000)
      .pipe(
        takeUntil(this.dispose$),   
        filter(() => !this._isLoading),     
        mergeMap(() => {
          this._isLoading = true;
          return this.configService.get(this._page, this._pageSize, this._filterText)
        })
        ,)
      .subscribe({
        next: (result) => {
          this._isLoading = false;
          this.logger.log("update result with new data", result.page, result.pageSize);
          this.result.next(result);
          this.error.next(undefined);
        },
        error: (error) => {
          this._isLoading = false;
          this.dispose(); //dispose is called in case of failure
          return this.error.next(`Failed to load configurations due to: ${handleError(error)}`);
        }
      }
      );
  }

  async dispose() {
    await super.dispose();
    this._subscription.unsubscribe();
  }
}
